import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef } from 'react';
import { send } from '@giantmachines/redux-websocket';
import uuid from 'uuid/v4';
import { DateTime } from 'luxon';
import {
  getChatPayloadData,
  getIsChatFetching,
  getLastMessageId,
  getReportChannel,
} from '../../../redux/chat/selectors';
import { chatActions } from '../../../redux/chat/actions';
import * as APIs from '../../../server/report';
import { wsActions } from '../../../redux/ws/actions';

export const useReportChannel = (report, query) => {
  const dispatch = useDispatch();
  const lastMessageId = useSelector(getLastMessageId);
  const channel = useSelector(getReportChannel(report));

  const channelData = useSelector(getChatPayloadData(report));

  const isFetching = useSelector(getIsChatFetching);
  const didDispatch = useRef(false);
  const fetchData = () => {
    dispatch(chatActions.startFetching());

    APIs.excel({
      data: {
        query,
        report,
      },
      success: (grid) => {
        dispatch(chatActions.sendData({ channelId: channel.id, data: grid, report }));
      },
      error: (messages) => {
        dispatch(wsActions.setSocketError(messages[0]));
        dispatch(chatActions.stopFetching());
      },
    });
  };

  const reFetchData = () => {
    dispatch(chatActions.startFetching());

    APIs.excel({
      data: {
        query,
        report,
      },
      success: (grid) => {
        dispatch(chatActions.replaceData({
          channelId: channel.id, data: grid, report, id: channelData && channelData.id,
        }));
      },
      error: (messages) => {
        dispatch(wsActions.setSocketError(messages[0]));
        dispatch(chatActions.stopFetching());
      },
    });
  };

  const scrollToBottom = (to) => {
    const id = document.getElementById(to);
    if (id) {
      id.scrollIntoView();
    }
  };


  const handleSendMessage = (value) => {
    dispatch(send({
      app: 'chat', event: 'message', action: 'request', data: { chat_id: channel.id, text: value },
    }));
    dispatch(chatActions.fillUserMessage({
      id: lastMessageId ? lastMessageId + 1 : uuid(),
      report_id: report,
      text: value,
      message_type: 'user',
      created_at: DateTime.now(),
    }));
    scrollToBottom('anchor');
    dispatch(wsActions.startWaiting());
  };

  useEffect(() => {
    if (channelData) {
      dispatch(chatActions.checkTokens({ id: channel.id, additional_text: '' }));
    }
  }, [channelData]);

  useEffect(() => {
    if (channel) {
      dispatch(chatActions.fetchMessages(channel.id));
    }
  }, [channel]);

  useEffect(() => {
    if (!isFetching && !channel && !didDispatch.current && report) {
      didDispatch.current = true;
      dispatch(chatActions.createChannel(report));
    }
  }, [channel, isFetching, report, dispatch]);

  const onClick = () => {
    if (!channel) {
      dispatch(chatActions.createChannel(report));
    }
  };

  return {
    isFetching,
    channel,
    onClick,
    handleSendMessage,
    fetchData,
    reFetchData,
  };
};
